import branchModelValidator from './branch';

export default branchModelValidator;
